import { BACKEND_URL } from "@/lib/api";

// POST to an SSE endpoint and call onDelta for each text chunk. Resolves with the full text.
export async function streamPost(path, body, { onDelta, signal } = {}) {
  const res = await fetch(`${BACKEND_URL}/api${path}`, {
    method: "POST", credentials: "include", headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: JSON.stringify(body), signal,
  });
  if (!res.ok) {
    let detail = "Something went wrong. Please try again.";
    try { const j = await res.json(); detail = typeof j.detail === "string" ? j.detail : j.detail?.message || detail; } catch { /* keep default */ }
    throw new Error(detail);
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let full = "";
  let meta = {};
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const events = buffer.split("\n\n");
    buffer = events.pop();
    for (const ev of events) {
      if (!ev.startsWith("data: ")) continue;
      const payload = JSON.parse(ev.slice(6));
      if (payload.delta) { full += payload.delta; onDelta?.(payload.delta, full); }
      if (payload.error) throw new Error(payload.error);
      if (payload.done) meta = payload;
    }
  }
  return { text: full, ...meta };
}
